import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { AppContext } from "~/scripts/context/app";

class Heading extends Component {
    static propTypes = {
        children: PropTypes.node,
        outline: PropTypes.bool
    };

    static defaultProps = {
        outline: false
    };

    static contextType = AppContext;

    render() {
        const { children, outline } = this.props;
        const { theme, browserInfo } = this.context;

        const useAlternate =
            browserInfo.browser && browserInfo.platform
                ? browserInfo.browser.name === "Safari" &&
                  browserInfo.platform.type === "desktop"
                : false;

        return (
            <h2
                className={classNames("heading", `theme-${theme}`, {
                    "heading--outline": outline,
                    "heading--standard": !useAlternate,
                    "heading--alternate": useAlternate
                })}
            >
                {children}
            </h2>
        );
    }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/scripts/components/Heading.js